<!--
 * @Author       : Bruce
 * @Date         : 2024-12-24 11:26:54
 * @LastEditors  : Bruce
 * @LastEditTime : 2025-03-29 21:45:18
 * @FilePath     : /app/javascript/dashboard/components/layout/sidebarComponents/Logo.vue
 * @Description  :
 * Copyright 2025 Bruce, All Rights Reserved.
 * 2024-12-24 11:26:54
-->
<script>
import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  props: {
    source: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    dashboardPath() {
      return frontendURL(`accounts/${this.accountId}/dashboard`);
    },
    sourceWithVersion() {
      // 使用固定版本号，每次更新logo时递增此版本号
      return `${this.source}?v=100`;
    },
  },
};
</script>

<template>
  <div class="w-8 h-8">
    <router-link :to="dashboardPath" replace>
      <img :src="sourceWithVersion" :alt="name" />
    </router-link>
  </div>
</template>
